import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheBloomExperience from "./sections/TheBloomExperience";
import OurFloralOfferings from "./sections/OurFloralOfferings";
import TheArtOfTheBar from "./sections/TheArtOfTheBar";
import MomentsInBloom from "./sections/MomentsInBloom";
import KindWords from "./sections/KindWords";
import FacebookTestimonials from "./sections/FacebookTestimonials";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheBloomExperience />
      <OurFloralOfferings />
      <TheArtOfTheBar />
      <MomentsInBloom />
      <KindWords />
      <FacebookTestimonials />
      <Footer />
    </div>;
}